<template>
  <div class="wish-list-edit-order-page__container">
    <div class="feedback">
      <transition name="fade" @enter="enterErrorFeedback">
        <FeedbackError
          v-if="showableErrorFeedback"
          :message="feedbackErrorMessage"
        />
      </transition>
    </div>
    <div class="wish-list-edit-order-page__page-header-area">
      <PageHeadlineTitle title="ほしいものリスト並べ替え" />
    </div>
    <div class="wish-list-edit-order-page__main-area">
      <div class="wish-list-edit-order-page__main-content">
        <div
          v-if="showBoxListAlert"
          class="wish-list-edit-order-page__box-list-area"
        >
          <ul class="box-list--alert wish-list-edit-order-page__box-list">
            <li v-if="hasValidationError">
              お手数ですが画面を読み込み直して再度お試しください
            </li>
          </ul>
        </div>
        <ul class="wish-list-edit-order-page__caption-ul">
          <li class="wish-list-edit-order-page__caption-li">
            登録したギフトの並び順の変更と削除ができます
          </li>
          <li class="wish-list-edit-order-page__caption-li">
            他の人が見たときも同じ並び順で表示されます
          </li>
          <li class="wish-list-edit-order-page__caption-li">
            移動したいギフトを長押ししてお好きな場所に差し込むこともできます
          </li>
        </ul>
        <div class="wish-list-edit-order-page__form-area">
          <SmallLoading
            v-if="isUserWishListsLoading"
            class="wish-list-edit-order-page__loading"
          />
          <div v-else>
            <draggable
              v-model="userWishLists"
              item-key="id"
              :delay="LONG_PRESS_SEC"
              @end="onEndDrag"
            >
              <template #item="{ element, index }">
                <WishListItemForEditOrder
                  :key="element.id"
                  :user-wish-list-id="element.id"
                  :image-url="element.imageUrl"
                  :brand-name="element.brandName"
                  :item-name="element.itemName"
                  :item-sku-name="element.itemSkuName"
                  :item-id="element.itemId"
                  :item-sku-id="element.itemSkuId"
                  :is-use-setting-checked="element.isUseSettingChecked"
                  :has-limit="element.hasLimit"
                  :is-sold-out="element.isSoldOut"
                  :wanted-quantity="element.wantedQuantity"
                  :received-quantity="element.receivedQuantity"
                  :is-up-button-disabled="index === 0"
                  :is-down-button-disabled="index === userWishLists.length - 1"
                  @click-up="onClickUp(index)"
                  @click-down="onClickDown(index)"
                  @click-top="onClickTop(index)"
                  @click-bottom="onClickBottom(index)"
                />
              </template>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <div class="wish-list-edit-order-page__submit-area">
      <div class="wish-list-edit-order-page__submit-buttons">
        <ButtonSecondary
          text="キャンセル"
          class="wish-list-edit-order-page__cancel-button"
          :disabled="isSubmitButtonDisable || null"
          @click-secondary-button="clickCancelButton"
        />
        <ButtonPrimary
          text="変更を保存"
          class="wish-list-edit-order-page__submit-button"
          :disabled="isSubmitButtonDisable || null"
          @click-primary-button="clickSubmitButton"
        />
      </div>
    </div>
    <TextModalWithSecondary
      v-if="showCancelDialog"
      title-text="変更内容が保存されていません"
      caption-text=""
      primary-button-text="編集を続ける"
      secondary-button-text="保存せずに前の画面に戻る"
      cancel-button-text="閉じる"
      @clicked-modal-cover="closeCancelModal"
      @clicked-primary="closeCancelModal"
      @clicked-secondary="backToWishListPage"
      @clicked-cancel="closeCancelModal"
    />
  </div>
</template>
<script>
import FeedbackError from '../../../atoms/feedbacks/feedback-error.vue'
import PageHeadlineTitle from '../../../atoms/headlines/PageHeadlineTitle.vue'
import SmallLoading from '../../../atoms/loadings/SmallLoading.vue'
import WishListItemForEditOrder from '../../../molecules/wish_list/WishListItemForEditOrder.vue'
import ButtonSecondary from '../../../molecules/buttons/ButtonSecondary.vue'
import ButtonPrimary from '../../../molecules/buttons/ButtonPrimary.vue'
import TextModalWithSecondary from '../../../molecules/modals/with_secondary/text-modal-with-secondary.vue'
import { draggableConstants } from '../../../../constants/draggableConstants'

import axios from 'axios'
import { cloneDeep, isEqual } from 'lodash'
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
    FeedbackError,
    PageHeadlineTitle,
    SmallLoading,
    WishListItemForEditOrder,
    ButtonSecondary,
    ButtonPrimary,
    TextModalWithSecondary
  },
  props: {
    isApp: {
      type: Boolean,
      required: true
    },
    screenName: {
      type: String,
      required: true
    }
  },
  setup() {
    const LONG_PRESS_SEC = draggableConstants.LONG_PRESS_SEC
    return { LONG_PRESS_SEC }
  },
  data() {
    return {
      showableErrorFeedback: false,
      feedbackErrorMessage: '',
      isUserWishListsLoading: true,
      userWishLists: [],
      initialUserWishLists: [],
      hasValidationError: false,
      isSubmitButtonDisable: false,
      showCancelDialog: false
    }
  },
  computed: {
    showBoxListAlert() {
      return this.hasValidationError
    },
    changeAnyValue() {
      return !isEqual(this.initialUserWishLists, this.userWishLists)
    }
  },
  mounted() {
    this.getUserWishLists()
  },
  methods: {
    enterErrorFeedback() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    showError(error) {
      this.showableErrorFeedback = true
      this.errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
    },
    async getUserWishLists() {
      this.isUserWishListsLoading = true
      this.isSubmitButtonDisable = true
      try {
        const res = await axios.get(
          `/api/v1/wish_lists?screen_name=${this.screenName}`
        )
        this.userWishLists = res.data.data.map(wishListTicket => {
          // TODO: dummyimage を正式が画像に置換する
          const itemSkuImageUrl = wishListTicket.attributes.item_sku_image_url
            ? wishListTicket.attributes.item_sku_image_url
            : 'https://dummyimage.com/90x90/ccc/999.png&text=Not+Found'
          return {
            id: wishListTicket.attributes.id,
            imageUrl: itemSkuImageUrl,
            itemSkuId: wishListTicket.attributes.item_sku_id,
            itemSkuName: wishListTicket.attributes.item_sku_name,
            itemId: wishListTicket.attributes.item_id,
            itemName: wishListTicket.attributes.item_name,
            brandName: wishListTicket.attributes.item_sku_brand_name,
            hasLimit: wishListTicket.attributes.has_limit,
            isSoldOut: wishListTicket.attributes.is_sold_out,
            wantedQuantity: wishListTicket.attributes.wanted_quantity,
            receivedQuantity: wishListTicket.attributes.received_quantity
          }
        })

        this.initialUserWishLists = cloneDeep(this.userWishLists)
        this.isUserWishListsLoading = false
        this.isSubmitButtonDisable = false
      } catch (error) {
        this.isUserWishListsLoading = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.feedbackErrorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    },
    pushRearrangeDataLayer(how) {
      if (!this.isApp) {
        dataLayer.push({
          event: 'click_edit_order__rearrange',
          how: how
        })
      } else {
        logEvent('click_edit_order__rearrange', {
          how: how
        })
      }
    },
    onEndDrag() {
      this.pushRearrangeDataLayer('drag')
    },
    onClickUp(index) {
      if (index === 0) {
        return
      }
      this.pushRearrangeDataLayer('up')
      this.moveUserWishListAt(index, index - 1)
    },
    onClickDown(index) {
      if (index === this.userWishLists.length - 1) {
        return
      }
      this.pushRearrangeDataLayer('down')
      this.moveUserWishListAt(index, index + 1)
    },
    onClickTop(index) {
      if (index === 0) {
        return
      }
      this.pushRearrangeDataLayer('top')
      this.moveUserWishListAt(index, 0)
    },
    onClickBottom(index) {
      if (index === this.userWishLists.length - 1) {
        return
      }
      this.pushRearrangeDataLayer('bottom')
      this.moveUserWishListAt(index, this.userWishLists.length - 1)
    },
    moveUserWishListAt(index, at) {
      if (index === at) return
      if (index < 0 || index > this.userWishLists.length - 1) return
      if (at < 0 || at > this.userWishLists.length - 1) return

      const value = this.userWishLists[index]

      this.userWishLists.splice(index, 1)
      this.userWishLists.splice(at, 0, value)
    },
    clickCancelButton() {
      this.isSubmitButtonDisable = true
      if (this.changeAnyValue) {
        this.showCancelDialog = true
      } else {
        this.backToWishListPage()
      }
    },
    backToWishListPage() {
      window.location = `/u/${this.screenName}`
    },
    closeCancelModal() {
      this.showCancelDialog = false
      this.isSubmitButtonDisable = false
    },
    async clickSubmitButton() {
      this.isSubmitButtonDisable = true

      if (!this.isApp) {
        dataLayer.push({
          event: 'click_edit_order__save'
        })
      } else {
        logEvent('click_edit_order__save')
      }

      try {
        const res = await axios.post(`/api/v1/wish_lists/update_order`, {
          user_wish_lists: this.userWishLists
        })
        if (res.data.saved) {
          window.location = `/u/${this.screenName}`
        } else {
          this.hasValidationError = res.data.has_validation_error

          window.scrollTo({ top, behavior: 'smooth' })
          this.showableErrorFeedback = true
          this.feedbackErrorMessage = 'エラーが発生しました'
          this.isSubmitButtonDisable = false
        }
      } catch (error) {
        this.isSubmitButtonDisable = false
        this.showableErrorFeedback = true
        // error.response.data.message が null の場合に備えて初期値をセットする
        this.feedbackErrorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-edit-order-page {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__page-header-area {
    background: $white;
    height: 76px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__main-area {
    background: $white;
    margin-top: 16px;
  }

  &__main-content {
    max-width: $small-contents-width;
    margin: auto;
    padding-top: 32px;
  }

  &__box-list-area {
    text-align: left;
    padding: 0 16px;
    margin-bottom: 24px;
  }

  &__box-list {
    padding: 16px;

    li {
      @extend %minimal;
      color: $danger;
    }
  }

  &__caption-ul {
    padding: 0 16px 24px 32px;

    li {
      @extend %caption;
      list-style: disc;
      text-align: left;
    }
  }

  &__loading {
    padding-bottom: 16px;
  }

  &__submit-area {
    background-color: $white;
    border-top: 1px solid $gray-2;
    position: sticky;
    bottom: 0;
    z-index: 2; // WishListItemForEditOrderの長押し時の「移動する」のカバーでz-index: 1を使用しているので、2を設定。
  }

  &__submit-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    max-width: $small-contents-width;
    margin: auto;
    padding: 24px 16px;
  }

  &__cancel-button {
    border-color: $gray-1;
    color: $gray-1;
    width: 148px;
  }

  &__submit-button {
    width: 148px;
  }
}
</style>
